import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Log } from 'app/core/logging/log';

@Component({
    selector: 'app-signin',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {

    @Output() goTo = new EventEmitter<any>();
    @Output() callbackFunction = new EventEmitter<any>();
    form: FormGroup;
    
    constructor(
        private restService: RestService,
        private appService: AppService
    ) { }

    ngOnInit() {
        this.initForm();
    }

    initForm(){

        this.form = new FormGroup({
            'tenantId': new FormControl(this.appService.tenantId,[
                Validators.required,
                Validators.min(1)
            ]),
            'usernameOrEmail': new FormControl('',[
                Validators.required,
                //Validators.minLength(4),
                Validators.email
            ]),
            'password': new FormControl('',[
                Validators.required,
                Validators.minLength(6),
                //Validators.maxLength(20),
            ]),
            'langCode': new FormControl(AppService.langSel.name, [
                Validators.required
            ])
        });
        
    }
    
    _goTo(value: string){
        Log.debug("_goTo", {value:value});
        this.goTo.emit(value);
    }

    
    get tenantId() { return this.form.get('tenantId'); }
    get usernameOrEmail() { return this.form.get('usernameOrEmail'); }
    get password() { return this.form.get('password'); }
    
    login(){
        this.validateAllFormFields(this.form);
        if (this.form.invalid) {
            Log.debug("Formulario no valido", {form:this.form});
            return;
        }
        const tenantId = Number(this.form.get('tenantId')?.value);
        AppService.clearToken();
        this.appService.tenantId = tenantId;
        this.restService.login(this.form.value).subscribe(result => {
            this.appService.showSuccessToast('Bienvenido');
            this.appService.usuario.username = result.username;
            this.appService.usuario.id = result.id;
            this.appService.usuario.email = result.email;
            this.appService.setToken(result.token);
            AppService.autenticado = true;
            this.appService.setCurrentUser(result);
            this.callbackFunction.emit();
        });
      }

      
    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
          const control = formGroup.get(field);
          if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
          } else if (control instanceof FormGroup) {
            this.validateAllFormFields(control);
          }
        });
    }
    
}
